// extracted by mini-css-extract-plugin
export var body = "drawer-module--body--3e2de";
export var close = "drawer-module--close--48dc6";
export var content = "drawer-module--content--42322";
export var header = "drawer-module--header--5405e";
export var title = "drawer-module--title--3b9d9";